import swal from 'sweetalert'

export function successMessage(message) {
    swal({
        text: message,
        icon: 'success',
        button: false,
        closeOnEsc: true,
        timer: 2000
    })
}

export function errorMessage(message) {
    swal({
        text: message,
        icon: 'error',
        button: false,
        closeOnEsc: true,
        timer: 2000
    })
}

export function warningMessage(message) {
    swal({
        text: message,
        icon: 'warning',
        button: false,
        closeOnEsc: true,
        timer: 2000
    })
}

export default {
    successMessage,
    errorMessage,
    warningMessage
}
